// extracted by mini-css-extract-plugin
export default {"button":"myProjectsButton_button__GCQ-h","rotate":"myProjectsButton_rotate__d2lqg","arrow":"myProjectsButton_arrow__dvvG7"};